export class ContentRules {
    static init() {
        var roots = document.querySelectorAll('[data-content-rules]');
        if (!roots.length) {
            return;
        }

        roots.forEach(function (root) {
            var trigger = root.querySelector('[data-content-rules-open]');
            var modal = root.querySelector('[data-content-rules-modal]');
            var closeButtons = root.querySelectorAll('[data-content-rules-close]');

            if (!trigger || !modal) {
                return;
            }

            trigger.addEventListener('click', function () {
                ContentRules.openModal(modal, trigger);
            });

            closeButtons.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    ContentRules.closeModal(modal, trigger);
                });
            });

        });

        document.addEventListener('keydown', function (event) {
            if (event.key !== 'Escape') {
                return;
            }

            roots.forEach(function (root) {
                var trigger = root.querySelector('[data-content-rules-open]');
                var modal = root.querySelector('[data-content-rules-modal]');
                if (trigger && modal && !modal.hasAttribute('hidden')) {
                    ContentRules.closeModal(modal, trigger);
                }
            });
        });
    }

    /**
     * @param {HTMLElement} modal
     * @param {HTMLElement} trigger
     */
    static openModal(modal, trigger) {
        modal.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('content-rules-modal-open');
    }

    /**
     * @param {HTMLElement} modal
     * @param {HTMLElement} trigger
     */
    static closeModal(modal, trigger) {
        modal.setAttribute('hidden', 'hidden');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('content-rules-modal-open');
    }
}
